import { atom } from "jotai";
import { AxiosInstance } from "axios";
import useApi, {
	ApiActions,
	ApiStatus,
	emptyApiState,
	Pagination,
} from "src/hooks/api/utils/useApi";
import useAuth from "src/hooks/selectors/useAuth";

type State = {
	totals: {
		break: number;
		total: number;
		price: number;
		approved: number;
	};
	status: ApiStatus;
	actions: ApiActions;
	api: AxiosInstance;
	pagination: Pagination;
};

const totalsAtom: any = atom(emptyApiState);

type Options = {
	task_id: number | string;
	filter?: any;
};

function useTimesheetsTotals(options: Options): State {
	const auth = useAuth();
	const { state, actions, api, pagination } = useApi(totalsAtom, {
		baseUrl: `/${auth.type}/tasks/${options.task_id}/timesheets/totals`,
		query: {
			task_id: options.task_id,
			...(options?.filter || {}),
		},
	});

	return {
		totals: state?.data || {},
		status: state.status,
		pagination,
		actions,
		api,
	};
}

export default useTimesheetsTotals;
